export const AGENT_HUB_BOOKING_ONBOARDING_ATTRIBUTE = 'data-agent-hub-onboarding'

export type AgentHubBookingOnboardingStepId =
  | 'account'
  | 'customer-view'
  | 'products'
  | 'search'
  | 'welcome'

export type AgentHubBookingOnboardingStep = {
  id: AgentHubBookingOnboardingStepId
}

export const AGENT_HUB_BOOKING_ONBOARDING_STEPS: Array<AgentHubBookingOnboardingStep> = [
  { id: 'welcome' },
  { id: 'products' },
  { id: 'search' },
  { id: 'customer-view' },
  { id: 'account' },
]

export function agentHubBookingOnboardingSelector(
  stepId: AgentHubBookingOnboardingStepId,
): string {
  return `[${AGENT_HUB_BOOKING_ONBOARDING_ATTRIBUTE}="${stepId}"]`
}

const TABLET_ONLY_STEP_IDS = new Set<AgentHubBookingOnboardingStepId>(['products', 'search'])

export function getVisibleAgentHubBookingOnboardingSteps(
  includeTabletOnlySteps: boolean,
): Array<AgentHubBookingOnboardingStep> {
  if (includeTabletOnlySteps) {
    return AGENT_HUB_BOOKING_ONBOARDING_STEPS
  }

  return AGENT_HUB_BOOKING_ONBOARDING_STEPS.filter(step => !TABLET_ONLY_STEP_IDS.has(step.id))
}
